import { Invoice, Pagination as IPagination } from '../../../../gql/types'
import { Pagination, Button, ButtonColor } from '../../../../components'
import { Icon, IconType } from '../../../../components/Icon'
import { ListItem } from './ListItem'

const TableHead = () => {
  return (
    <thead className='bg-white'>
      <tr>
        <th
          scope='col'
          className='py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-600 sm:pl-6'
        >
          Date
        </th>
        <th
          scope='col'
          className='px-3 py-3.5 text-left text-sm font-semibold text-gray-600'
        >
          Amount
        </th>
        <th
          scope='col'
          className='px-3 py-3.5 text-left text-sm font-semibold text-gray-600'
        >
          Status
        </th>
        <th
          scope='col'
          className='relative py-3.5 pl-3 pr-4 text-left text-sm font-semibold text-gray-600 sm:pr-6'
        >
          <span className='sr-only'> Download invoice PDF</span>
        </th>
      </tr>
    </thead>
  )
}

interface IProps {
  invoices: Invoice[]
  hasMore: boolean
  isFirstPage: boolean
  onLoadMore: () => void
  onLoadFirst: () => void
  loading?: boolean
}

const InvoicesList = ({
  invoices,
  hasMore,
  isFirstPage,
  onLoadMore,
  onLoadFirst,
  loading = false,
}: IProps) => {
  return (
    <>
      {/* Table with invoices */}
      <table className='min-w-full divide-y divide-gray-300'>
        <TableHead />
        <tbody className='divide-y divide-gray-200 bg-white'>
          {invoices.length === 0 && !loading && (
            <tr>
              <td
                colSpan={4}
                className='text-center py-8 text-sm text-gray-500'
              >
                No invoices found.
              </td>
            </tr>
          )}
          {invoices.map((invoice, index) => (
            <ListItem key={invoice.id} invoice={invoice} index={index} />
          ))}
        </tbody>
      </table>

      {/* Cursor-based pagination - show current page info only */}
      {invoices.length > 0 && (
        <div className='flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6'>
          <div className='flex flex-1 items-center justify-between'>
            <div>
              <p className='text-sm text-gray-700'>
                {hasMore ? (
                  <>
                    Showing{' '}
                    <span className='font-medium'>{invoices.length}</span>{' '}
                    invoices
                    <span className='text-gray-500 ml-1'>(more available)</span>
                  </>
                ) : (
                  <>
                    Showing{' '}
                    <span className='font-medium'>{invoices.length}</span>{' '}
                    invoices
                    {!isFirstPage && (
                      <span className='text-gray-500 ml-1'>
                        (end of results)
                      </span>
                    )}
                  </>
                )}
              </p>
            </div>
            <div className='flex space-x-2'>
              <Button
                title='First'
                type='button'
                colour={ButtonColor.secondary}
                onClick={onLoadFirst}
                disabled={isFirstPage}
                icon={
                  <Icon type={IconType.chevronLeft} className='text-white' />
                }
                iconPosition='left'
              />
              {hasMore && (
                <Button
                  title='Next '
                  type='button'
                  colour={ButtonColor.primary}
                  onClick={onLoadMore}
                  disabled={loading}
                  loading={loading}
                  icon={
                    <Icon type={IconType.chevronRight} className='text-white' />
                  }
                  iconPosition='right'
                  width='100px'
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export { InvoicesList }
